import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from 'src/store';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import { setMoveTabValue } from 'src/store/MoveTab';
import { PopupComponent } from './PopupComponent';

export default function AlertDialog(props: any) {
  //const { tabVal, setTabVal, move } = useTab();
  const confirmexitvalue: any = useSelector((state: AppState) => state.confirmexitvalue);
  const confirmexitpopupval: any = useSelector((state: AppState) => state.confirmexitpopupval);
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (confirmexitpopupval.confirmexitpopupval == true && confirmexitvalue.confirmexitvalue == true) {
      //props.setMoveTab(false);
      setOpen(true);
      localStorage.setItem('popupShowed', 'true');
    } else {
      setOpen(false);
      localStorage.setItem('popupShowed', 'false');
      props.setValue(props.prevClicked);
    }
  }, [confirmexitpopupval, props.prevClicked]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleYes = () => {
    setOpen(false);
    setMoveTabValue(dispatch, true);
    props.setValue(props.prevClicked);
    setConfirmExitValue(dispatch, false);
    setConfirmExitPopupVal(dispatch, false);
  };
  return (
    <div>
      <PopupComponent
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
      >
        <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Changes you made will not be saved. Would you like to discard them and proceed to next page?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} className="grey-btn">
            Close
          </Button>
          <Button onClick={handleYes} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </PopupComponent>
    </div>
  );
}
